import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ActionContextProvider } from './context/ActionContext';
import './utils/customMethods';
const root = ReactDOM.createRoot(
	document.getElementById('raven-atlas-app') as HTMLElement
);

root.render(
	// <React.StrictMode>
	<BrowserRouter>
		<ActionContextProvider>
			<App />
		</ActionContextProvider>
	</BrowserRouter>
	// </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(logger.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
